var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5817_3816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5717 4.3058H10.0003V2.28795C10.0003 1.97188 9.74492 1.71652 9.42885 1.71652H2.14314V1.00223C2.14314 0.923661 2.07885 0.859375 2.00028 0.859375H1.00028C0.921708 0.859375 0.857422 0.923661 0.857422 1.00223V15.0022C0.857422 15.0808 0.921708 15.1451 1.00028 15.1451H2.00028C2.07885 15.1451 2.14314 15.0808 2.14314 15.0022V10.2879H6.57171V12.3058C6.57171 12.6219 6.82707 12.8772 7.14314 12.8772H14.5717C14.8878 12.8772 15.1431 12.6219 15.1431 12.3058V4.87723C15.1431 4.56116 14.8878 4.3058 14.5717 4.3058ZM2.14314 9.00223V3.00223H8.71457V9.00223H2.14314ZM13.8574 11.5915H7.85742V10.2879H9.85742C9.936 10.2879 10.0003 10.2237 10.0003 10.1451V5.59152H13.8574V11.5915Z",
    fill: "#258750"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5817_3816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.4c3b5b9a27659c8ab3522c59d73544e5.svg";
export { ForwardRef as ReactComponent };